<div class="flex flex-col max-w-240 md:min-w-160 -m-6">

  <!-- Header -->
  <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-warn text-on-warn">
    <div class="text-lg">{{ data.title | transloco }} 😢</div>
    <button mat-icon-button (click)="dialogRef.close(false)" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <!-- Compose form -->
  <div class="flex flex-col flex-auto p-6 sm:p-8 overflow-y-auto">
    @if (data.message) {
      <p [innerHTML]="data.message | transloco | bypassSecurityTrustHtml"></p>
    }
    <div class="text-error">{{data.agaveErrorCode}}</div>
  </div>

</div>
